import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Settings } from '@/types/api.types';

interface AuthState {
  user: User | null;
  settings: Settings | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, settings: Settings, token: string) => void;
  updateSettings: (settings: Settings) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      settings: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, settings, token) => {
        localStorage.setItem('token', token);
        set({ user, settings, token, isAuthenticated: true });
      },
      updateSettings: (settings) => {
        set({ settings });
      },
      logout: () => {
        localStorage.removeItem('token');
        set({ user: null, settings: null, token: null, isAuthenticated: false });
      },
    }),
    {
      name: 'msa-auth',
      partialize: (state) => ({
        user: state.user,
        settings: state.settings,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
